module.exports = __webpack_public_path__ + "static/img/8.ae74a1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/8.png
// module id = S5GA
// module chunks = 0